export const SET_PATH_PARAMS = 'GET_PATH_PARAMS';
export const CLEAR_PATH_PARAMS = 'CLEAR_PATH_PARAMS';
